import { QueryKey } from "@tanstack/react-query";

export const noteQueryKeys = {
  all: () => ["note"] as QueryKey,
  search: (filters: Readonly<{ [k: string]: any }>) =>
    [...noteQueryKeys.all(), { filters }] as QueryKey,
  details: (noteId?: number) => [...noteQueryKeys.all(), noteId] as QueryKey,
};
